<template>
  <div class="page-header">
    <div class="page-header__container">
      <div class="page-header__title" data-test="page-header__title">
        {{ title }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String, required: true },
  },
};
</script>
<style lang="stylus" scoped>
@import '../../assets/css/main.styl';

.page-header {
  width: 100%;
  height: 90px;
  background: $secondary-color;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.page-header__container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.page-header__title {
  color: #fff;
  font-size: $main-title-size;
}
</style>
